import React, { useEffect } from 'react';
import { RestaurantDetails_getRestaurantDetails } from '../../../../../types/graphql-types-generated.ts';
import { Map } from '../../../../../components/map/map.tsx';
import { Button } from '../../../../../patterns/00-atoms/button/button.tsx';
import { UBTracking } from '../../../../../components/tracking/ubtracking.ts';
import { RestaurantMembershipType } from './membership.tsx';

export type RestaurantInfoModalMapProps = {
  restaurantDetails: RestaurantDetails_getRestaurantDetails;
};

export const RestaurantInfoModalMap: React.FunctionComponent<
  RestaurantInfoModalMapProps
> = props => {
  const navigateButtonRef = React.useRef<HTMLAnchorElement>(null);
  const navigationLink = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${props.restaurantDetails.street} ${props.restaurantDetails.streetnumber}, ${props.restaurantDetails.linkedCity.name}`)}`;

  useEffect(() => {
    if (navigateButtonRef.current) {
      UBTracking.onTrackTargetView(
        navigateButtonRef.current,
        'restaurant_info_modal',
        'navigate_to_restaurant',
        'google_maps'
      );
    }
  }, []);

  return (
    <div className="text-sm">
      <h3 className="mt-3 text-xl font-extrabold">Adresse</h3>
      <div className="mt-2 flex">
        <div className="flex-grow">
          <div className="font-bold">
            {props.restaurantDetails.street} {props.restaurantDetails.streetnumber}
          </div>
          <div className="font-medium">
            {props.restaurantDetails.zip} {props.restaurantDetails.linkedCity.name}
          </div>
        </div>
        <div>
          <Button
            ref={navigateButtonRef}
            href={navigationLink}
            target="_blank"
            onClick={() =>
              UBTracking.trackEvent.click(
                'restaurant_info_modal',
                'navigate_to_restaurant',
                'google_maps'
              )
            }
          >
            Navigieren
          </Button>
        </div>
      </div>
      {props.restaurantDetails.geoLat && props.restaurantDetails.geoLong && (
        <div className="mt-4 -mr-4 -mb-4 -ml-4 overflow-hidden rounded-b-3xl">
          <Map
            lat={props.restaurantDetails.geoLat}
            lng={props.restaurantDetails.geoLong}
            premium={props.restaurantDetails.membershipType === RestaurantMembershipType.PREMIUM}
          />
        </div>
      )}
    </div>
  );
};
